import { useMemo } from "react";

/** `?site_settings_variant=test` — preview del borrador en /admin/country-templates. */
export function useSiteSettingsVariant(): "live" | "test" {
  return useMemo((): "live" | "test" => {
    if (typeof window === "undefined") return "live";
    return new URLSearchParams(window.location.search).get("site_settings_variant") ===
      "test"
      ? "test"
      : "live";
  }, []);
}